import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslateCacheService } from 'ngx-translate-cache';
import { exhaustMap, map, Observable, shareReplay, Subject } from 'rxjs';
import { IUserModel } from 'src/app/core/models/masters/user-master.model';
import { BaseRepository } from 'src/app/infrastructure/infrastructure-services/respositories/base/base-repository';
import { MasterLayoutServiceService } from '../master-layout-service.service';
import { GenericService } from 'src/app/infrastructure/infrastructure-services/services/base/generic-service';
import { HttpClient } from '@angular/common/http';
import { GlobalProperties } from 'src/app/global/global-properties';
import {LoginPageComponent} from 'src/app/login-layout/login-page/login-page.component'
import { WrapperStandardFilter } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { LoginApiMasterService } from 'src/app/login-layout/Service/login-api-master.service';
import { SecurityService } from 'src/app/login-layout/Service/security.service';
import { OidcClientManagerService } from 'src/app/login-layout/service-oidc/oidc-client-manager.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {
  curretUserInfo:any;
  public isExpanded = true;
  public reconnectSub = new Subject<boolean>();
  sidebarShown: boolean = false;
  isBlueTheme: boolean = false;
  @Output() toggleSidebarHandler: EventEmitter<boolean> = new EventEmitter();

  public toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }

  menuList: any;
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches),
      shareReplay()
    );

  constructor(private breakpointObserver: BreakpointObserver,  private oidcClientManager: OidcClientManagerService,
     private securityService: SecurityService, public masterMenuLayout: MasterLayoutServiceService, public translateCacheService: TranslateCacheService,
    public translate: TranslateService, private router: Router, private baseRepository: BaseRepository<IUserModel>, public generic: GenericService<any>, private httpClient: HttpClient
    ,  @Inject(MAT_DIALOG_DATA) private data: any,
         public matDialogforCfl: MatDialog, private http: HttpClient, private loginService: LoginApiMasterService,
     public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<any>>,
      public agenericRepositoryForCfl: GenericService<any>,
      public routerForCfl: Router, private dbService: NgxIndexedDBService,) {

      
  }
  tabChange(event: string) {
    this.router.navigate(['/home/' + event]);

  }

  // changeLanguge(event:any) {
  //   console.log(event);
  //   this.translate.use(event);
  //   this.translate.setDefaultLang(event);
  //   localStorage.setItem('lang', event);
  // location.reload()
  // this.translate.use(event.value.code);
  // this.translate.setDefaultLang(event.value.code);
  // localStorage.setItem('lang', event.value.code);

  //   }
  // switchLang(lang: string) {
  //   let langCheck = '';
  //   this.translate.use(lang);
  //   langCheck = lang;
  //   this.masterMenuLayout.setOption(langCheck);
  // }
  ngOnInit() {

    let data: any = sessionStorage.getItem('currentUser');
      this.curretUserInfo=JSON.parse(data);
      console.log(' this.curretUserInfo', this.curretUserInfo)
     
   this.reconnect();
   this.themeSwitch('blue');

  }

  public logout() {
  let loginWithSSO=  sessionStorage.getItem('loginWithSSO');
  if(loginWithSSO=='true')
    this.oidcClientManager.startSignoutRedirect()
    sessionStorage.clear();
    localStorage.clear();
    this.translate.use('en'); 
    this.router.navigate(['']);
  
  }

  callSAPLoginAPI(): any {
    let sapDetails:any
    if(sessionStorage.getItem('data-from-api')==='true'){

      let sapInfo=sessionStorage.getItem('sapDetails')
      sapDetails = JSON.parse(this.securityService.decryptWithPrivateKey(JSON.stringify(sapInfo)));

    }
    else{

      sapDetails=GlobalProperties.getSapInfo;
     
      sapDetails['UserName']=this.curretUserInfo.UserName
      sapDetails['Password']=this.curretUserInfo.Password


    }
  
   let mdata = `${sapDetails.ServiceLayerURL}Login`;
    if (mdata) {

      var data = {
        CompanyDB: `${sapDetails.CompanyDB}`,
        UserName: `${sapDetails.UserName}`,
        Password: `${sapDetails.Password}`
      }

      return this.generic.PostAPIWithOptions(mdata, data, { withCredentials: true });
    }
  }

    callSAPLoginAPIForOneLogin(): any {
    let sapDetails:any
    if(sessionStorage.getItem('data-from-api')==='true'){

      let sapInfo=sessionStorage.getItem('sapDetails')
      sapDetails = JSON.parse(this.securityService.decryptWithPrivateKey(JSON.stringify(sapInfo)));

    }
    else{

      sapDetails=GlobalProperties.getSapInfo;
     
    
    }
  
   let mdata = `${sapDetails.ServiceLayerURL}Login`;
    if (mdata) {

      var data = {
        CompanyDB: `${sapDetails.CompanyDB}`,
        UserName: `${GlobalProperties._oneLoginUserName}`,
        Password: `${GlobalProperties._oneLoginPassword}`
      }

      return this.generic.PostAPIWithOptions(mdata, data, { withCredentials: true });
    }
  }


  public reconnect() {
 let oneLogin= sessionStorage.getItem("OneLoginUser");
    this.reconnectSub.pipe(exhaustMap(() =>oneLogin=='true'?this.callSAPLoginAPIForOneLogin():this.callSAPLoginAPI())).subscribe({
      next: (res: any) => {
        if (res["SessionId"] != null) {
          localStorage.setItem("SAPsessionId", res["SessionId"]);
        }
      }
    });
  }
  


   onOpenDropDown(value: any) {
      let genCFL = new GenericCflViewComponent<any>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data, this.dbService);
        let filter: WrapperStandardFilter = new WrapperStandardFilter();
      if (value == 'Branch') {
        genCFL.setCflTitle = "Select Default Branch";
        genCFL.setCflViewDataSourceURL = 'Branch/GetBranchListService';
        genCFL.setCflDisplayedColumnsNamesList = ['branchName', 'stateName', 'countryName'];
        // genCFL.setCflSelectedData = this.selectedData;
        genCFL.setCFLIsCancel = false
        genCFL.setSortColumn = "branchName";

        filter.Key = 'disabled';
        filter.OperatorType = 'contains';
        filter.Value = 'N'
        genCFL.setCflFilterArray = filter;
        
      }
  
      filter.Key = 'disabled';
      filter.OperatorType = 'contains';
      filter.Value = 'N'
      genCFL.setCflFilterArray = filter;
      
      genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
      
        if (res != undefined && res.event != undefined) {
          if (value == 'Branch') {
            localStorage.setItem("BranchId", res.event.bplid);
            localStorage.setItem("BranchName", res.event.branchName);
            window.location.reload();
          
          }
        }
      })
    }


    getFirstTwoChars(word: string):any{
      if(word)
      return word.substring(0, 2).toUpperCase(); // Extracts the first two characters
    }

    toggleSidebar() {
      this.sidebarShown = !this.sidebarShown;
      this.toggleSidebarHandler.next(this.sidebarShown);
    }

    themeSwitch(theme: string) {
      const body = document.getElementsByTagName('body')[0];
      if(theme == 'blue') {
        this.isBlueTheme = true;
        body.classList.add('theme-blue'); 
      }else {
        this.isBlueTheme = false;
        body.classList.remove('theme-blue');
      }
    }
    
}
